// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h1[data-v-35e10596]{font-size:20px}", "",{"version":3,"sources":["webpack://layouts/error.vue"],"names":[],"mappings":"AACA,oBACE,cACF","sourcesContent":["\nh1 {\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
